// extracted by mini-css-extract-plugin
export default {"tooltipText":"_452w3u"};